import React from 'react';
import { FaHandHoldingUsd, FaMoneyCheckAlt } from 'react-icons/fa';
import { GiTargeting } from 'react-icons/gi';
import { BsGraphUp } from 'react-icons/bs';
import { GiRobotGolem } from 'react-icons/gi';
import { FiBarChart2 } from 'react-icons/fi';

const WhyInggage = () => {
  return (
    <div className="py-10 px-8 mx-12 xs:mx-4 xs:px-4 md:px-8 lg:px-40 text-center" style={{ fontFamily: "Gilroy-Medium" }}>
      <h2 className="text-2xl md:text-3xl font-bold mb-4 text-black">Why Inggage ?</h2>
      <p className="text-gray-600 max-w-xl mx-auto mb-10">
      At Inggage, we bridge the gap between brands and creators through a transparent, data-driven, and results-oriented platform.
      </p>

      <div className="flex flex-col lg:flex-row justify-between gap-15 xs:gap-5 lg:gap-20 text-left">
       { /* For Brands */}
            <div className="flex-1">
              <h3 className="text-xl font-semibold mb-3">For Brands</h3>
              <div className="space-y-1 ">
                <li className="flex items-start gap-4 hover:translate-x-2 transition-transform duration-200">
                  <FaHandHoldingUsd className=" text-xl mt-1" />
                  <div>
                <p className="font-medium mb-0">Pay only for real engagement</p>
                <p className="text-sm text-gray-600">No upfront fees, only results</p>
                  </div>
                </li>
                <li className="flex items-start gap-4 hover:translate-x-2 transition-transform duration-200">
                  <GiTargeting className=" text-xl mt-1" />
                  <div>
                <p className="font-medium mb-0">AI-driven influencer selection</p>
                <p className="text-sm text-gray-600">Data-backed campaign targeting</p>
                  </div>
                </li>
                <li className="flex items-start gap-4 hover:translate-x-2 transition-transform duration-200">
                  <BsGraphUp className=" text-xl mt-1" />
                  <div>
                <p className="font-medium mb-0">Advanced tracking & ROI reporting</p>
                <p className="text-sm text-gray-600">Real-time performance insights</p>
                  </div>
                </li>
              </div>
              <button className="mt-6 bg-[#EB0062] hover:bg-pink-700 text-white text-sm px-4 py-2 rounded-[12px]">
                Join as a Brand
              </button>
            </div>

            <div className="hidden lg:block w-px bg-gray-300" />

            {/* For Creators */}
        <div className="flex-1">
          <h3 className="text-xl font-semibold mb-3">For Creators</h3>
          <div className="space-y-1">
          <li className="flex items-start gap-4 hover:translate-x-2 transition-transform duration-200">
              <FaMoneyCheckAlt className=" text-xl mt-1" />
              <div>
                <p className="font-medium mb-0">Get paid fairly</p>
                <p className="text-sm text-gray-600">
                  Performance-based monetization – CPC, CPV
                </p>
              </div>
            </li>
            <li className="flex items-start gap-4 hover:translate-x-2 transition-transform duration-200">
              <GiRobotGolem className=" text-xl mt-1" />
              <div>
                <p className="font-medium mb-0">AI-powered brand matching</p>
                <p className="text-sm text-gray-600">
                  Connects creators with relevant campaigns
                </p>
              </div>
            </li>
            <li className="flex items-start gap-4 hover:translate-x-2 transition-transform duration-200">
              <FiBarChart2 className=" text-xl mt-1" />
              <div>
                <p className="font-medium mb-0">Real-time content analytics</p>
                <p className="text-sm text-gray-600">Track performance & earnings</p>
              </div>
            </li>
          </div>
          <button className="mt-6 bg-[#EB0062] hover:bg-pink-700 text-white text-sm px-4 py-2 rounded-[12px]">
            Join as a creator
          </button>
        </div>
      </div>
    </div>
  );
};

export default WhyInggage;
